export default "__VITE_PUBLIC_ASSET__e1f1e54c__"